export default {
    id: 'pl',
    noDesktop: {
        line1: 'SSStrasznie nam przykro',
        line2: 'aktualnie Atas nie jest dostosowany do urzadzeń nie mobilnych. Zmniejsz ekran lub uruchom naszą aplikacje pobierając ją z Sklepu Play lub App Store.',
    },
    logIn: {
        hello: 'Witaj w',
        btn1: 'Zaloguj z Discord ',
        btn2: 'Regulamin i klauzula RODO',
        authCompleted: 'Zalogowano pomyślnie! wróć do aplikacji.',
    },
}